if (!customElements.get('vicca-product-hero')) {
  class ViccaProductHero extends HTMLElement {
    constructor() {
      super();
      this.tones = Array.from(this.querySelectorAll('[data-vicca-tone]'));
      this.variantInput = this.querySelector('.product-variant-id');
      this.submitButton = this.querySelector('.product-form__submit');
      this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
      this.priceEl = this.querySelector('[data-vicca-product-hero-price]');
      this.linkEl = this.querySelector('[data-vicca-product-hero-link]');
      this.titleEl = this.querySelector('[data-vicca-product-hero-title]');
      this.titleTemplate = this.dataset.titleTemplate || '';
      this.video = this.querySelector('[data-vph-video]');
      this.image = this.querySelector('[data-vph-image]');
      this.mobileSource = this.image ? this.image.parentElement.querySelector('source') : null;

      this.tones.forEach((tone) => {
        tone.addEventListener('click', () => this.selectTone(tone));
      });

      if (this.video && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.removeAttribute('autoplay');
        this.video.pause();
      }
    }

    selectTone(tone) {
      if (tone.hasAttribute('disabled')) return;

      this.tones.forEach((t) => {
        t.classList.remove('vicca-product-hero__tone--selected');
        t.setAttribute('aria-checked', 'false');
      });
      tone.classList.add('vicca-product-hero__tone--selected');
      tone.setAttribute('aria-checked', 'true');

      const variantId = tone.dataset.variantId;
      const available = tone.dataset.variantAvailable === 'true';

      if (this.image && tone.dataset.toneImage && this.image.src !== tone.dataset.toneImage) {
        const img = this.image;
        if (this.mobileSource) this.mobileSource.remove(), (this.mobileSource = null);
        img.style.transition = 'opacity .25s ease';
        img.style.opacity = '0';
        const swap = () => {
          img.srcset = tone.dataset.toneSrcset || '';
          img.src = tone.dataset.toneImage;
          const show = () => { img.style.opacity = '1'; };
          if (img.decode) img.decode().then(show).catch(show); else show();
        };
        setTimeout(swap, 220);
      }

      if (this.variantInput) {
        this.variantInput.value = variantId;
        this.variantInput.disabled = !available;
      }

      if (this.submitButton) {
        this.submitButton.disabled = !available;
        this.submitButton.setAttribute('aria-disabled', String(!available));
      }

      if (this.submitButtonText && window.variantStrings) {
        this.submitButtonText.textContent = available
          ? window.variantStrings.addToCart
          : window.variantStrings.soldOut;
      }

      if (this.priceEl) {
        const comparePrice = tone.dataset.variantComparePrice;
        if (comparePrice) {
          this.priceEl.innerHTML =
            `<span class="vicca-product-hero__price-sale">${tone.dataset.variantPrice}</span>` +
            `<span class="vicca-product-hero__price-compare">${comparePrice}</span>`;
        } else {
          this.priceEl.textContent = tone.dataset.variantPrice;
        }
      }

      if (this.linkEl && tone.dataset.variantUrl) {
        this.linkEl.setAttribute('href', tone.dataset.variantUrl);
      }

      if (this.titleEl && this.titleTemplate.indexOf('[tono]') !== -1) {
        this.titleEl.textContent = this.titleTemplate.replace('[tono]', tone.dataset.variantTitle || '');
      }
    }
  }

  customElements.define('vicca-product-hero', ViccaProductHero);
}
